import React from 'react';
import s from '../solution-rate-reviews.scss';
import { FiveStars } from '../solution-rate/solution-rate-charts';
import { Avatar, Text, Box } from 'wix-style-react';
import { useConfigContext } from "../../../../../config-context";
export var ReviewTitle = function (props) {
    var imgSrc = props.userImg || '';
    // tslint:disable-next-line:react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    var publishedDate = isMobile ? "" + dateFormatter(props.publishDate) : "/ " + dateFormatter(props.publishDate);
    return (React.createElement(Box, { verticalAlign: "top" },
        React.createElement(Avatar, { name: nameToAvatarFormatter(props.name), imgProps: { src: imgSrc }, size: isMobile ? 'size36' : 'size48' }),
        React.createElement(Box, { direction: "vertical", marginLeft: isMobile ? "12px" : "18px", verticalAlign: "top" },
            React.createElement(Box, { className: s.reviewAuthor, direction: isMobile ? "vertical" : "horizontal", verticalAlign: "middle" },
                React.createElement("span", { property: "author", typeof: "Person" },
                    React.createElement(Text, { size: "small", weight: "normal", property: "name" }, "" + nameFormatter(props.name),
                        "\u00A0")),
                React.createElement(Text, { size: "small", weight: "thin" }, publishedDate)),
            React.createElement("span", { property: "reviewRating", typeof: "Rating" },
                React.createElement("meta", { property: "ratingValue", content: "" + props.rating })),
            props.rating && React.createElement(FiveStars, { starsToFill: props.rating, size: 18 }))));
};
export var nameFormatter = function (name) {
    var newName = name
        .toLocaleLowerCase()
        .split(' ')
        .map(function (n) { return n.charAt(0).toUpperCase() + n.slice(1); })
        .join(' ');
    return newName;
};
export var nameToAvatarFormatter = function (name) {
    return /\s/.test(name) && name
        ? name
        : name.length > 1
            ? name.charAt(0) + " " + name.charAt(1)
            : name.charAt(0) + " " + name.charAt(0);
};
var dateFormatter = function (dateToFormat) {
    var date = new Date(dateToFormat);
    var dateArr = date && date.toString().split(' ');
    var dateString = dateArr && dateArr[1] + ' ' + dateArr[2] + ', ' + dateArr[3];
    return dateString;
};
//# sourceMappingURL=solution-review-title.js.map